"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _hideVisually = _interopRequireDefault(require("../../../theming/styles/hideVisually"));

var _themeContants = require("../../../constants/themeContants");

var _theming = require("../../../theming");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var RadioPillItem = function RadioPillItem(_ref) {
  var children = _ref.children,
      id = _ref.id,
      group = _ref.group,
      disabled = _ref.disabled,
      onChange = _ref.onChange,
      className = _ref.className,
      defaultChecked = _ref.defaultChecked,
      value = _ref.value,
      full = _ref.full,
      variant = _ref.variant,
      otherProps = _objectWithoutProperties(_ref, ["children", "id", "group", "disabled", "onChange", "className", "defaultChecked", "value", "full", "variant"]);

  return _react["default"].createElement(RadioWrapper, _extends({
    className: className,
    full: full,
    variant: variant
  }, otherProps), _react["default"].createElement(Radio, {
    id: id,
    disabled: disabled,
    type: "radio",
    name: group,
    onChange: onChange,
    defaultChecked: defaultChecked,
    value: value,
    variant: variant
  }), _react["default"].createElement(Label, {
    variant: variant,
    htmlFor: id,
    full: full
  }, children));
};

RadioPillItem.themeProps = {
  label: {
    name: "RADIO_PILL_ITEM_LABEL",
    description: "Label style",
    type: _themeContants.themePropTypes.style
  },
  checked: {
    name: "RADIO_PILL_ITEM_CHECKED",
    description: "Checked style",
    type: _themeContants.themePropTypes.style
  },
  wrapper: {
    name: "RADIO_PILL_ITEM_WRAPPER",
    description: "Checked style",
    type: _themeContants.themePropTypes.style
  },
  hover: {
    name: "RADIO_PILL_ITEM_HOVER",
    description: "Checked style",
    type: _themeContants.themePropTypes.style
  }
};

var Label = _styledComponents["default"].label.withConfig({
  displayName: "RadioPillItem__Label",
  componentId: "sc-1c2o4vv-0"
})(["position:relative;padding:", " ", ";border:1px solid ", ";cursor:pointer;font-family:", ";font-size:", ";letter-spacing:normal;font-weight:", ";margin-right:-1px;background-color:", ";", ";", ";"], _theming.spacing.tiny, _theming.spacing.small, _theming.color.line, _theming.fontFamily.body(), _theming.font.input, _theming.fontWeight.normal, _theming.color.white, (0, _theming.applyVariants)(RadioPillItem.themeProps.label), function (p) {
  return p.full && (0, _styledComponents.css)(["width:calc(100% + 1px);justify-content:center;display:flex;align-items:center;"]);
});

var Radio = _styledComponents["default"].input.withConfig({
  displayName: "RadioPillItem__Radio",
  componentId: "sc-1c2o4vv-1"
})(["", ";&:checked{~ ", "{background-color:", ";color:", ";z-index:1;", ";}&:first-child ~ ", "{border-color:", ";}&:nth-child(2) ~ ", "{border-color:", ";}}"], _hideVisually["default"], Label, _theming.color.primary, _theming.color.white, (0, _theming.applyVariants)(RadioPillItem.themeProps.checked), Label, _theming.color.primary, Label, _theming.color.primary);

var RadioWrapper = _styledComponents["default"].div.withConfig({
  displayName: "RadioPillItem__RadioWrapper",
  componentId: "sc-1c2o4vv-2"
})(["display:", ";min-height:", ";padding-top:", ";padding-bottom:", ";", ";&:first-child{", "{border-top-left-radius:", ";border-bottom-left-radius:", ";}}&:last-child{", "{border-top-right-radius:", ";border-bottom-right-radius:", ";border-right-width:1px;margin-right:0;}}&:hover,", ":focus ~{", "{z-index:1;border-color:", ";", ";}}", ";"], function (p) {
  return p.full ? "flex" : "inline-block";
}, _theming.targetSize.normal, function (p) {
  return p.full ? null : _theming.spacing.small;
}, function (p) {
  return p.full ? null : _theming.spacing.small;
}, function (p) {
  return p.full && "flex-grow: 1";
}, Label, _theming.spacing.tiny, _theming.spacing.tiny, Label, _theming.spacing.tiny, _theming.spacing.tiny, Radio, Label, _theming.color.primary, (0, _theming.applyVariants)(RadioPillItem.themeProps.hover), (0, _theming.applyVariants)(RadioPillItem.themeProps.wrapper));

RadioPillItem.defaultProps = {
  disabled: false,
  input: {},
  onChange: null,
  value: "",
  defaultChecked: false,
  full: false
};
RadioPillItem.propTypes = {
  children: _themeContants.commonPropTypes.children.isRequired,
  className: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  group: _propTypes["default"].string,
  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
  input: _propTypes["default"].any,
  onChange: _propTypes["default"].func,
  defaultChecked: _propTypes["default"].bool,
  value: _propTypes["default"].any,
  full: _propTypes["default"].bool
};
var _default = RadioPillItem;
exports["default"] = _default;